import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="container mx-auto px-4 py-8 text-white"
    >
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        At Fantasy Fiesta, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
      </p>
      <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
      <p className="mb-4">
        We may collect personal information that you voluntarily provide to us when you register on the site, participate in activities, or use certain services.
      </p>
      <h2 className="text-xl font-semibold mb-2">How We Use Your Information</h2>
      <p className="mb-4">
        We use the information we collect to provide, maintain, and improve our services, to communicate with you, and to personalize your experience.
      </p>
      <h2 className="text-xl font-semibold mb-2">Data Sharing and Disclosure</h2>
      <p className="mb-4">
        We do not sell, trade, or otherwise transfer your personal information to outside parties except to provide services you have requested or to comply with legal obligations.
      </p>
      <h2 className="text-xl font-semibold mb-2">Security</h2>
      <p className="mb-4">
        We implement a variety of security measures to maintain the safety of your personal information.
      </p>
      <h2 className="text-xl font-semibold mb-2">Your Choices</h2>
      <p className="mb-4">
        You may choose to restrict the collection or use of your personal information by not providing it or by opting out of certain services.
      </p>
      <h2 className="text-xl font-semibold mb-2">Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
      </p>
      <p>
        If you have any questions about this Privacy Policy, please contact us.
      </p>
    </motion.div>
  );
};

export default PrivacyPolicy;
